const PageError = ({error={}}) => `PageError: ${error.message}`
export default PageError;